import { CENTERS } from '@/common/types/centers';
import { getDoctorCenterFacilitiesFromBiko } from '@/common/apis/services/biko/getDoctorCenterFacilities';
import type {
  CenterFacilitiesMap,
  CheraghFacilitiesPublicData,
} from '@/modules/profile/utils/cheraghFacilitiesProfile';
import { hasCheraghFacilitiesDisplayData } from '@/modules/profile/utils/cheraghFacilitiesProfile';

export const PROFILE_CENTER_FACILITIES_QUERY_KEY = 'profileCenterFacilities';

export async function fetchDoctorCenterFacilitiesMap(
  userId: string | number | null | undefined,
  centers: Array<{ id?: string | number } | null | undefined> | null | undefined,
  options?: { timeoutMs?: number },
): Promise<CenterFacilitiesMap> {
  const uid = String(userId ?? '').trim();
  if (!uid || !Array.isArray(centers) || centers.length === 0) return {};

  const officeCenters = centers.filter(
    c => c?.id != null && String(c.id) !== String(CENTERS.CONSULT),
  );
  if (officeCenters.length === 0) return {};

  // allSettled: one slow/failing center must not drop facilities already returned for others.
  const settled = await Promise.allSettled(
    officeCenters.map(async center => {
      const centerId = String(center!.id);
      const data = await getDoctorCenterFacilitiesFromBiko(uid, centerId, {
        timeoutMs: options?.timeoutMs ?? 1500,
      });
      return [centerId, data] as const;
    }),
  );

  const map: CenterFacilitiesMap = {};
  for (const result of settled) {
    if (result.status !== 'fulfilled') continue;
    const [centerId, data] = result.value;
    if (hasCheraghFacilitiesDisplayData(data)) {
      map[centerId] = data as CheraghFacilitiesPublicData;
    }
  }
  return map;
}
